export default {
  title: "Perfiles"
  , button: { privileges: "Privilegios" }
  , form: {
    nombre: {
      label: "Nombre de perfil"
      , th: "Nombre"
    }
    , descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD2000: { text: "Ocurrió un error en el catálogo de Perfiles" }
    , WS2000: { text: "Ocurrió un error en el catálogo de Perfiles" }
    , JS2000: { text: "Ocurrió un error en el catálogo de Perfiles" }
    , CR2000: { text: "Ocurrió un error en el catálogo de Perfiles" }
    , UK_Perfil_nombre: { text: "Ya existe un grupo con el mismo nombre" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/seguridad/perfil.js